module.exports = __webpack_public_path__ + "img/iot4.b40c5297.png";